import React, { useState } from 'react';
import { WizardProvider } from '../contexts/WizardContext';
import WizardProgressIndicator from '../components/wizard/WizardProgressIndicator';
import CloutWizardStep1 from '../components/wizard/CloutWizardStep1';
import Step2Services from '../components/wizard/Step2Services';
import Step3Practices from '../components/wizard/Step3Practices';
import CalculationPopup from '../components/wizard/CalculationPopup';
import SignupRedirectPopup from '../components/wizard/SignupRedirectPopup';
import { useWizard } from '../contexts/WizardContext';

// CLOUT logo
import cloutLogo from '../assets/logos/clout-logo.png';

const WizardContent: React.FC = () => {
  const { currentStep } = useWizard();
  const [showCalculation, setShowCalculation] = useState(false);
  const [showSignupRedirect, setShowSignupRedirect] = useState(false);

  const steps = ['Basic Info', 'Services', 'Experience'];

  const handleCalculationComplete = () => {
    setShowCalculation(false);
    setShowSignupRedirect(true);
  };

  // Show calculation popup when reaching step 4
  React.useEffect(() => {
    if (currentStep === 4) {
      setShowCalculation(true);
    }
  }, [currentStep]);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-[#eaeaea]">
        <div className="container mx-auto px-4 py-3 sm:py-4">
          <div className="flex items-center justify-between">
            <img src={cloutLogo} alt="CLOUT" className="h-8 sm:h-10 lg:h-12" />
            <h1 className="hidden sm:block font-['Ovo',_serif] text-[18px] sm:text-[20px] lg:text-[24px] text-[#1f1f1f] uppercase">
              Provider Assessment
            </h1>
            {/* Mobile step indicator */}
            <span className="sm:hidden font-['Open_Sans'] text-sm text-[#767472]">
              Step {currentStep}/3
            </span>
          </div>
        </div>
      </header>

      {/* Progress Indicator */}
      {currentStep <= 3 && <WizardProgressIndicator currentStep={currentStep} steps={steps} />}

      {/* Wizard Content */}
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="max-w-4xl mx-auto">
          {currentStep === 1 && <CloutWizardStep1 />}
          {currentStep === 2 && <Step2Services />}
          {currentStep === 3 && <Step3Practices />}
        </div>
      </main>

      {/* Popups */}
      <CalculationPopup isOpen={showCalculation} onComplete={handleCalculationComplete} />

      <SignupRedirectPopup
        isOpen={showSignupRedirect}
        onClose={() => setShowSignupRedirect(false)}
      />
    </div>
  );
};

const CloutWizard: React.FC = () => {
  return (
    <WizardProvider>
      <WizardContent />
    </WizardProvider>
  );
};

export default CloutWizard;
